import { Injectable } from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class CommonService {

  readonly GetUserType: string = 'admin';
  readonly GetTherapeuticList: string = 'users/therapeutic';
  readonly CreateTherapeuticList: string = 'users/create';
  readonly CreateAdminUser: string = 'admin';
  readonly GetAllAppUserList: string = 'users/all';
  readonly GetAppUserDetail: string = 'users/app';
  readonly DeleteAppUser: string = 'users/deleteUser';
  readonly ChangeAppUserPassword: string = 'admin/changeUserPassword';
  readonly GetLoggedinUserDetail: string = 'admin/get-admin-detail';
  readonly FileUpload: string = 'upload';
  readonly CreateEvent: string = 'events/createEvent';
  readonly UpdateEvent: string = 'events/updateEvents';
  readonly GetAllEvent: string = 'events/admin/list';
  readonly GetAllEventParticipant: string = 'events/admin/eventRegistrationList';
  readonly GetEventDetail: string = 'events/eventsDetail';
  readonly DeleteEvent: string = 'events/deleteEvents';
  readonly SearchEvent: string = 'events/admin/search';
  readonly GetParticipantList: string = 'events/registerUsers';
  readonly GetAdditionalParticipantList: string = 'events/participantDetail';
  readonly UpdateParticipantstatus: string = 'events/updateRegistration';
  readonly UpdateAdditionalParticipantstatus: string = 'events/updateParticipants';
  readonly getEventShareById: string = 'events/view';
  readonly getEventList: string = 'questionnaire/events';
  readonly getQuestionnaireList: string = 'questionnaire/list';
  readonly createQuestionnaire: string = 'questionnaire/create';
  readonly deleteQuestionnaire: string = 'questionnaire/delete';
  readonly updateQuestionnaire: string = 'questionnaire/update';
  readonly viewQuestionnaireResponse: string = 'questionnaire/viewResponse';
  readonly getUserAnswer: string = 'questionnaire/checkUserAns';
  readonly downloadAllResponse: string = 'questionnaire/overAllResponse';
  readonly GetAllCheckIn: string = 'checkin/list';
  readonly GetCheckInInfo: string = 'checkin/checkUser';
  readonly SearchCheckIn: string = 'checkin/search';
  readonly GetAllFAQList: string = 'faq/list-faq';
  readonly CreateFAQ: string = 'faq/create-faq';
  readonly UpdateFAQ: string = 'faq/edit-faq';
  readonly DeleteFAQ: string = 'faq/delete-faq';
  readonly AskedQuestionList: string = 'faq/list-askquestion';
  readonly RepostOnIssueList: string = 'faq/list-issues';
  readonly GetRepostIssueDetail: string = 'faq/getdetails-issues';
  readonly GetAllPastEvent: string = 'events/admin/pastEvent';
  readonly uploadImage: string = 'upload'

  //dashboard
  readonly GetDashboardDetail: string = 'admin/dashboard';

  //cms for policy and terms and conditions
  readonly SavePolicyTerms: string = 'cms/create';
  readonly UpdatePolicyTerms: string = 'cms/update';
  readonly GetPolicyTerms: string = 'cms/view';

  //reports
  readonly UserListReport: string = 'reports/userlist';
  readonly FaqListReport: string = 'reports/faqlist';
  readonly AskQuestionReport: string = 'reports/askquestion';
  readonly ReportIssuesReport: string = 'reports/reportissues';
  readonly getEventQuestion: string = 'reports/eventQuestions';
  readonly getEventPolls: string = 'reports/eventPolls';
  readonly getEventFeedback: string = 'reports/eventFeedback';
  readonly getEventParticipantList: string = 'reports/getEventParticipantsList';
  readonly getEventCheckinList: string = 'reports/getEventCheckinList';
  readonly getEventPollList: string = 'reports/getEventPollList';
  readonly getEventQuestionsList: string = 'reports/getEventQuestionsList';
  readonly getEventFeedbackList: string = 'reports/getEventFeedbackList';
  readonly getReportEvent: string = 'reports/eventList';

  //polls
  readonly GetPollsList: string = 'poll/list';
  readonly CreatePolls: string = 'poll/create';
  readonly UpdatePolls: string = 'poll/update';
  readonly DeletePolls: string = 'poll/delete';
  readonly ViewPollsResponse: string = 'poll/viewResponse';
  readonly DownloadAllPollsResponse: string = 'poll/overAllResponse';
  readonly PollsCheckUserResponse: string = 'poll/checkUserAns';

  // Feedback
  readonly FeedbackList: string = 'feedback/list';
  readonly CreateFeedback: string = 'feedback/create';
  readonly UpdateFeedback: string = 'feedback/update';
  readonly FeedbackResponse: string = 'feedback/viewResponse';
  readonly FeedbackUserResponse: string = 'feedback/checkUserAns';
  readonly DownloadOverAllFeedbackResponse: string = 'feedback/overAllResponse';
  readonly DeleteFeedback: string = 'feedback/delete';

  // Contact Us
  readonly ContactUsList: string = 'contact/list';

  // Account Delete Request
  readonly getAllDeleteRequest: string = 'admin/account/deleteRequestsList';
  readonly deleteUserRequest: string = 'admin/deleteUser';

  // Co-Host Feature
  readonly TransferOwnership: string = 'events/transferOwnership';
  readonly AddCoHosts: string = 'events/addCoHosts';
  readonly RemoveCoHosts: string = 'events/removeCoHosts';
  readonly GetCohostEligibleUsers: string = 'admin/users/cohost-eligible';
}
